export function TableCard({ table, joinTable }) {
    return (
        <div className="truco-table-card">
            <div className="truco-table-header">
                <h3 className='truco-table-title'>{table.tableId}</h3>
                <span className={`truco-card-status ${table.status.toLowerCase()}`}>BUY IN : {table.wagerAmount}</span>
            </div>
            <div className="truco-table-info">
                <p><strong>Seats:</strong> {table.numOccupiedSeats}/{table.numberOfSeats}</p>
                <button
                    className='truco-table-card-button'
                    disabled={!table.canJoin}
                    onClick={() => { joinTable(table.tableId) }}>
                    {table.numOccupiedSeats
                        ? table.numOccupiedSeats === table.numberOfSeats
                            ? "FULL"
                            : "WAITING"
                        : "JOIN"}
                </button>
            </div>
        </div>
    );
}